import { APIEndpointEnum } from 'config/constants/server'
import {
  AdventureUserRewardResponse,
  AdventureUserStatsReward,
  WagerAdventure,
} from 'config/types/bonus/WagerAdventure'
import { HunnyPlayRequest } from './HunnyPlayRequest'
import { BaseResponse, HunnyRequest } from './types'

class WagerAdventureService extends HunnyPlayRequest {
  public async getAdventure(): Promise<BaseResponse<WagerAdventure>> {
    let response = await this._request(APIEndpointEnum.ActiveAdventure, null, {
      excludeErrors: ['error_data_not_found'],
    })

    if (!response?.data || Number(response?.data?.id || 0) === 0) {
      response = await this._request(APIEndpointEnum.ExpireAdventure)
    }
    return response
  }

  public getListUserReward(promotionId: number): HunnyRequest<BaseResponse<AdventureUserRewardResponse[]>> {
    const response = this._post(APIEndpointEnum.ListUserReward, {
      promotion_id: promotionId,
    })
    return response
  }
  public getUserStats(promotionId: number): HunnyRequest<BaseResponse<AdventureUserStatsReward>> {
    const response = this._post(
      APIEndpointEnum.AdventureUserStats,
      {
        promotion_id: promotionId,
      },
      { authRequest: true },
    )
    return response
  }
}

const instance = new WagerAdventureService()
export default instance
